var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsApp = function SvgWhatsApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1.2 1.45 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21L4.65 17.2C3.61 15.62 3.24 13.73 3.6 11.9C3.96 10.07 5.03 8.45 6.57 7.36C8.11 6.28 10.01 5.8 11.89 6.03C13.77 6.26 15.49 7.18 16.72 8.61C17.95 10.04 18.6 11.87 18.55 13.76C18.5 15.64 17.75 17.44 16.45 18.8C15.15 20.17 13.39 21 11.51 21.14C9.63 21.28 7.77 20.72 6.28 19.56L3 21Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10C9 10.28 9.22 10.5 9.5 10.5C9.78 10.5 10 10.28 10 10V9.5C10 9.22 9.78 9 9.5 9C9.22 9 9 9.22 9 9.5V10C9 12.49 11.01 14.5 13.5 14.5H14C14.28 14.5 14.5 14.28 14.5 14C14.5 13.72 14.28 13.5 14 13.5H13.5C13.22 13.5 13 13.72 13 14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWhatsApp;